export default class WebSocketClass {
  /**
   * @description: 初始化实例属性，保存参数
   * @param {String} url ws的接口
   * @param {Function} msgCallback 服务器信息的回调传数据给函数
   * @param {Function} successCallback 成功回调
   * @param {String} name 可选值 用于区分ws，用于debugger
   */
  constructor(url, msgCallback, successCallback, name = 'websocket') {
    this.url = url
    this.msgCallback = msgCallback
    this.name = name
    this.ws = null // websocket对象
    this.status = null // websocket是否关闭
    this.pingInterval = null
    this.successCallback = successCallback
  }

  /**
   * @description: 初始化 连接websocket或重连webSocket时调用
   * @param {*} 可选值 要传的数据
   */
  connect(data) {
    // 新建 WebSocket 实例
    this.ws = new WebSocket(this.url)
    this.ws.onopen = e => {
      // 连接ws成功回调
      this.status = 'open'
      console.log(`${this.name}连接成功`, e)
      this.heartCheck()
      this.successCallback(e)
      if (data !== undefined) {
        // 有要传的数据,就发给后端
        return this.ws.send(data)
      }
    }
    // 监听服务器端返回的信息
    this.ws.onmessage = e => {
      // 把数据传给回调函数，并执行回调
      return this.msgCallback(e.data)
    }
    // ws关闭回调
    this.ws.onclose = e => {
      console.log(e)
      this.closeHandle(e) // 判断是否关闭
    }
    // ws出错回调
    this.onerror = e => {
      this.closeHandle(e) // 判断是否关闭
    }
  }

  heartCheck() {
    // 心跳机制的时间可以自己与后端约定
    if (this.status !== 'open') {
      this.closeHandle()
      return
    } // ws的心跳机制状态值
    this.pingInterval = setTimeout(() => {
      if (this.ws.readyState === 1) {
        // 检查ws为链接状态 才可发送
        this.ws.send(
          // JSON.stringify({type: -1, timestamp: new Date().getTime(), data: {msg: 'PING'}})
          'PING'
        ) // 客户端发送ping
        this.heartCheck()
      } else {
        this.status = ''
        this.closeHandle()
      }
    }, 30000)
  }

  // 发送信息给服务器
  sendHandle(data) {
    if (this.status !== 'open') {
      console.log(`websock为正常连接,重新连接,当前状态：${this.status}`)
      this.status = ''
      this.closeHandle()
      return
    }
    console.log(`${this.name}发送消息给服务器:`, data)
    return this.ws.send(data)
  }

  // 清空定时器
  clearFn() {
    if (this.pingInterval !== null) {
      console.log('清空定时器')
      // 清除定时器
      clearTimeout(this.pingInterval)
    }
  }

  closeHandle() {
    this.clearFn()
    // 因为webSocket并不稳定，规定只能手动关闭(调closeMyself方法)，否则就重连
    if (this.status !== 'close') {
      console.log('重连')
      setTimeout(() => {
        this.connect() // 重连
      }, 10000)
    } else {
      console.log(`${this.name}websocket手动关闭`)
      this.closeMyself()
    }
  }

  // 手动关闭WebSocket
  closeMyself() {
    this.clearFn()
    console.log(`关闭${this.name}`)
    this.status = 'close'
    return this.ws.close()
  }
}
